import React, { useRef, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Gallery = () => {
  const scrollRef = useRef(null);
  const [images, setImages] = useState([]);

  // Scroll function
  const scroll = (direction) => {
    const { current } = scrollRef;
    if (!current) return;
    if (direction === "left") {
      current.scrollBy({ left: -300, behavior: "smooth" });
    } else {
      current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  // Fetch photos from API
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch("https://gp-chandoli-khurd.com/backend/api/gallery/get_gallery.php");
        const data = await response.json();
        if (data.status === "success") {
          setImages(data.photos || []); // Assuming API returns {status:"success", photos: [...]}
        } else {
          console.error("Error fetching gallery:", data.message);
        }
      } catch (error) {
        console.error("Error fetching gallery:", error);
      }
    };

    fetchImages();
  }, []);

  return (
    <div className="relative max-w-6xl mx-auto py-10">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">छायाचित्र दालन</h2>

      <div className="relative">
        {/* Left Arrow */}
        <button
          onClick={() => scroll("left")}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 hover:bg-gray-100 transition"
        >
          <ChevronLeft size={24} />
        </button>

        {/* Images Container */}
        <div
          ref={scrollRef}
          className="flex overflow-x-auto space-x-4 scroll-smooth"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {images.length === 0 && (
            <p className="text-gray-500 px-4">कोणतेही फोटो उपलब्ध नाहीत</p>
          )}

          {images.map((img) => (
            <div key={img.id} className="min-w-[200px] flex-shrink-0">
              <img
                src={img.file_path} // API मधून आलेला file_path वापरा
                alt={img.title}
                className="rounded-lg object-cover w-full h-48 hover:scale-105 transition-transform"
              />
              <h3 className="text-sm font-semibold mt-2 text-gray-700">{img.title}</h3>
            </div>
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={() => scroll("right")}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 hover:bg-gray-100 transition"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default Gallery;